// extracted by mini-css-extract-plugin
export default {"search-bar-container":"SearchBar_search-bar-container__MRjtK","search-input":"SearchBar_search-input__rpDC6","search-button":"SearchBar_search-button__3zytu"};